export const AdminNavigation = [
  { name: 'Dashboard', href: '/admins/dashboard' },
  { name: 'Caregivers', href: '/admins/caregivers' },
  { name: 'All Completed Consults & Referrals', href: '/admins/completed' },
  { name: 'All Pending Consults & Referrals', href: '/admins/pending' },
]
